// Keep this fallback independent of App, storage, APIs and monitoring: it must
// also work when a startup chunk cannot be downloaded or evaluated.
export function showStartupFailure() {
  const host = document.getElementById("root");
  if (!host) return;
  // Production keeps its loading cover beside root. Remove it even when
  // App never loads and therefore cannot call its normal dismissal hook.
  document.getElementById("splash")?.remove();
  const title = document.createElement("h1");
  title.textContent = "MWF Ops could not load";
  const message = document.createElement("p");
  message.textContent = "Check your connection, then reload to try again.";
  const reload = document.createElement("button");
  reload.type = "button";
  reload.textContent = "Reload";
  reload.addEventListener("click", () => window.location.reload());
  host.replaceChildren(title, message, reload);
}
